export default __webpack_public_path__ + "static/media/TTNorms-Bold.d7e3362b.otf";